<template>
    <back-button :route="{ name: 'products' }"/>
    <div class="flex flex-col my-3">
        <user-heading
            v-if="storeProduct"
            :user="storeProduct.user"
        ></user-heading>

        <nav-tabs :tabs="tabs" class="mb-5" />

        <div class="flex justify-end mb-3">
            <button
                type="button"
                @click="openImportModal"
                class="inline-flex items-center justify-center px-4 py-2 text-sm font-semibold leading-6 text-white transition duration-150 ease-in-out bg-indigo-500 rounded-md shadow hover:bg-indigo-400"
            >
                <font-awesome-icon
                    icon="fa-solid fa-upload"
                    class="mr-2"
                    aria-hidden="true"
                />
                Importar Cupons
            </button>
        </div>

        <import-coupons-modal
            :product="storeProduct"
            :show="showImportModal"
            @close="closeImportModal"
            @imported="handleImportSuccess"
        />

        <table-component
            :loading="loading"
            :pagination="pagination"
            :headers="headers"
            @fetch="fetch"
            :selected="selected"
            :all-selected="all_selected"
        >
            <tr v-for="history in histories" :key="history.id">
                <td class="table-cell-sm">
                    <span
                        :title="history.user?.name || 'N/A'"
                        class="block max-w-[150px] truncate"
                        v-tooltip="history.user?.name || 'N/A'"
                    >
                        {{ history.user?.name || 'N/A' }}
                    </span>
                </td>
                <td class="table-cell-sm">
                    <span
                        :title="history.user?.email || 'N/A'"
                        class="block max-w-[200px] truncate"
                        v-tooltip="history.user?.email || 'N/A'"
                    >
                        {{ history.user?.email || 'N/A' }}
                    </span>
                </td>
                <td class="table-cell-sm">
                    <span class="block">
                        {{ history.coupons_count || 0 }} cupons
                    </span>
                </td>
                <td class="table-cell-sm">
                    <span class="block">
                        {{ formatDiscountType(history.discount_type) }}
                    </span>
                </td>
                <td class="table-cell-sm">
                    <span class="block">
                        {{ formatDiscount(history.discount, history.discount_type) }}
                    </span>
                </td>
                <td class="table-cell-sm">
                    <span
                        v-if="history.expires_at"
                        class="block"
                    >
                        {{ history.expires_at }}
                    </span>
                    <span v-else class="text-gray-400">
                        Sem expiração
                    </span>
                </td>
                <td class="table-cell-sm">
                    <span
                        class="inline-block px-2 py-1 text-xs font-semibold rounded"
                        :class="{
                            'bg-green-500 text-white': history.has_run,
                            'bg-yellow-500 text-white': !history.has_run,
                        }"
                    >
                        {{ history.has_run ? 'Processado' : 'Pendente' }}
                    </span>
                </td>
                <td class="table-cell-sm">
                    <span class="block text-sm text-gray-600 dark:text-gray-400">
                        {{ history.created_at || 'N/A' }}
                    </span>
                </td>
                <td class="table-cell-sm">
                    <button
                        v-if="hasErrors(history)"
                        @click="openErrorsModal(history)"
                        type="button"
                        class="inline-flex items-center px-3 py-1.5 text-xs font-medium text-white bg-red-600 rounded hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500"
                        title="Ver erros no processamento"
                    >
                        <font-awesome-icon
                            icon="fa-solid fa-exclamation-triangle"
                            class="mr-1"
                            aria-hidden="true"
                        />
                        Erros
                    </button>
                </td>
            </tr>
        </table-component>

        <coupon-errors-modal
            :show="showErrorsModal"
            :invalid-logs="selectedHistory?.invalid_logs || []"
            @close="closeErrorsModal"
        />
    </div>
</template>

<script>
import { mapActions, mapWritableState } from "pinia";
import Filters from "../../../components/layouts/Filters.vue";
import BackButton from "../../../components/layouts/navigation/BackButton.vue";
import NavTabs from "../../../components/layouts/NavTabs.vue";
import TableComponent from "../../../components/layouts/table/TableComponent.vue";
import { Store } from "../../../stores/store.js";
import UserHeading from "../../users/UserHeading.vue";
import CouponErrorsModal from "./modals/CouponErrorsModal.vue";
import ImportCouponsModal from "./modals/ImportCouponsModal.vue";

export default {
    name: "ProductCoupons",
    components: { BackButton, NavTabs, UserHeading, Filters, TableComponent, ImportCouponsModal, CouponErrorsModal },
    data() {
        return {
            tabs: [
                {
                    name: "details",
                    label: "Detalhes",
                    route: "product",
                    params: { product_id: this.$route.params.product_id },
                },
                {
                    name: "interactions",
                    label: "Interações",
                    route: "product.interactions",
                    params: { product_id: this.$route.params.product_id },
                },
                {
                    name: "students",
                    label: "Alunos",
                    route: "product.students",
                    params: { product_id: this.$route.params.product_id },
                },
                {
                    name: "members",
                    label: "Area de membros",
                    route: "product.members.contents",
                    params: { product_id: this.$route.params.product_id },
                },
                {
                    name: "coupons",
                    label: "Cupons",
                    route: "product.coupons",
                    params: { product_id: this.$route.params.product_id },
                }
            ],
            loading: false,
            histories: [],
            selected: [],
            all_selected: false,
            showImportModal: false,
            showErrorsModal: false,
            selectedHistory: null,
            pagination: {
                total: 0,
                per_page: 10,
                current_page: 1,
                last_page: 1,
                from: 1,
                to: 10,
            },
            filters: {
                text: "",
                types: [],
                date: [],
            },
        }
    },
    computed: {
        ...mapWritableState(Store, ["storeProduct", "permissions"]),
        headers() {
            return [
                "Usuário",
                "Email",
                "Quantidade",
                "Tipo Desconto",
                "Desconto",
                "Expira em",
                "Status",
                "Criado em",
                "Ações",
            ];
        },
    },
    async mounted() {
        if (!this.storeProduct) {
            await this.fetchProduct();
        }

        this.fetch();
    },
    methods: {
        ...mapActions(Store, ["fetchProduct"]),
        fetch() {
            this.loading = true;
            axios.get('/api/product/' + this.storeProduct.id + '/coupon/batch-history')
                .then(({data}) => {
                    // A API retorna um array simples de recursos
                    let filteredData = data;

                    // Aplicar filtro de texto se existir
                    if (this.filters.text) {
                        const searchText = this.filters.text.toLowerCase();
                        filteredData = data.filter(item => {
                            const userName = item.user?.name?.toLowerCase() || '';
                            const userEmail = item.user?.email?.toLowerCase() || '';
                            const productName = item.product?.name?.toLowerCase() || '';
                            return userName.includes(searchText) ||
                                   userEmail.includes(searchText) ||
                                   productName.includes(searchText);
                        });
                    }

                    // Aplicar paginação manualmente
                    const perPage = 10;
                    const total = filteredData.length;
                    const currentPage = this.pagination.current_page;
                    const start = (currentPage - 1) * perPage;
                    const end = start + perPage;

                    this.histories = filteredData.slice(start, end);
                    this.pagination = {
                        total: total,
                        per_page: perPage,
                        current_page: currentPage,
                        last_page: Math.ceil(total / perPage),
                        from: total > 0 ? start + 1 : 0,
                        to: Math.min(end, total),
                    };
                    this.loading = false;
                })
                .catch((error) => {
                    console.error('Erro ao buscar históricos de cupons:', error);
                    this.histories = [];
                    this.loading = false;
                });
        },
        formatDiscountType(type) {
            const types = {
                'percentual': 'Percentual',
                'fixed': 'Fixo',
            };
            return types[type] || type;
        },
        formatDiscount(discount, type) {
            if (!discount) return 'N/A';
            return type === 'percentual'
                ? `${discount}%`
                : `R$ ${parseFloat(discount).toFixed(2).replace('.', ',')}`;
        },
        openImportModal() {
            this.showImportModal = true;
        },
        closeImportModal() {
            this.showImportModal = false;
        },
        handleImportSuccess() {
            this.fetch();
        },
        hasErrors(history) {
            return history.invalid_logs && history.invalid_logs.length > 0;
        },
        openErrorsModal(history) {
            this.selectedHistory = history;
            this.showErrorsModal = true;
        },
        closeErrorsModal() {
            this.showErrorsModal = false;
            this.selectedHistory = null;
        },
    }
}
</script>

